import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://dznggoutqhvcofyrduqp.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR6bmdnb3V0cWh2Y29meXJkdXFwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQwNTI0MTMsImV4cCI6MjA3OTYyODQxM30.bNaYOhuNdnBM5-63ejLUzPsb16WiXlM6Y4LCOKixkg4'

export const supabase = createClient(supabaseUrl, supabaseKey)